<script lang="ts">
// Семантический тон бейджа. Доменные статусы (роль, статус пакета, unread) НЕ живут
// в компоненте — маппинг «домен → tone» держат страницы-потребители (call-site).
export type BadgeTone = 'neutral' | 'accent' | 'good' | 'warn' | 'crit'
</script>

<script setup lang="ts">
defineProps<{ tone: BadgeTone }>()

const classes: Record<BadgeTone, string> = {
  neutral: 'bg-surface-2 text-muted',
  accent: 'bg-accent-soft text-accent-ink',
  good: 'bg-good-soft text-good',
  warn: 'bg-warn-soft text-warn',
  crit: 'bg-crit-soft text-crit',
}
</script>

<template>
  <span :class="['inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold', classes[tone]]">
    <slot />
  </span>
</template>
